let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ar2ov")).then(() => parcelRequire('6EGmj'));